<template>
  <div class="wrap">
    <a-layout-footer>
      <div class="footer">
        <div flex flex-column logo>
          <h2 class="logo">
            <img :src="logo" width="100%" alt="img" />
          </h2>
          <div class="slogan">
            <p style="word-wrap: break-word;">
              {{ footerDesc }}
            </p>
          </div>
        </div>
        <div flex flex-column>
          <h2>销售联系方式</h2>
          <div flex flex-column>
            <p>电话：{{ contact.sale.telephone }}</p>
            <p>手机：{{ contact.sale.phone }}</p>
            <p>联系人：{{ contact.sale.contact }}</p>
            <p style="display:flex;align-items:center;">
              QQ：{{ contact.sale.qq }}
              <HYQQLinks
                mystyle="margin-left:5px;"
                :qq="contact.sale.qq"
                custom
              >
                <svg
                  t="1618235824129"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2207"
                  width="20"
                  height="20"
                >
                  <path
                    d="M511.999 1024a512 512 0 1 0-512-512 512 512 0 0 0 512 512z"
                    fill="#23A0F0"
                    p-id="2208"
                  ></path>
                  <path
                    d="M735.765 604.422c-3.55-49.47-36.192-90.932-55.09-112.47a70.383 70.383 0 0 0-15.577-67.003v-1.718c0-97.235-68.028-167.254-153.35-167.55-85.333 0.342-153.35 70.315-153.35 167.55v1.718a70.383 70.383 0 0 0-15.576 67.003c-18.898 21.413-51.54 62.874-55.09 112.47a75.39 75.39 0 0 0 7.554 40.425c7.555 10.308 28.513-2.06 43.406-34.93a210.33 210.33 0 0 0 35.499 67.914c-36.307 8.477-46.729 44.897-34.475 64.853 8.59 14.086 28.445 25.657 62.419 25.657 60.473 0 87.267-16.611 99.18-28.057a16.259 16.259 0 0 1 20.844 0c11.913 11.57 38.684 28.057 99.18 28.057 34.02 0 53.715-11.57 62.419-25.657 12.253-19.922 1.831-56.342-34.475-64.853a211.627 211.627 0 0 0 35.499-67.914c14.893 32.87 35.85 45.124 43.406 34.93a76.493 76.493 0 0 0 7.577-40.425z"
                    fill="#FFFFFF"
                    p-id="2209"
                  ></path>
                </svg>
              </HYQQLinks>
            </p>
            <p>微信：{{ contact.sale.wechat }}</p>
            <p>邮箱：{{ contact.sale.email }}</p>
          </div>
        </div>
        <div flex flex-column>
          <h2>通讯方式</h2>
          <div flex flex-column>
            <p>电话：{{ contact.sale.tax }}（北京总部）</p>
            <p>传真：{{ contact.sale.tax }}（北京总部）</p>
            <p>电话：{{ contact.sz.telephone }}（深圳办事处）</p>
            <p>邮箱：{{ contact.sz.email }}</p>
          </div>
        </div>
        <div flex flex-column>
          <h2>公司地址</h2>
          <div flex flex-column>
            <p v-for="(e, i) in contact.address" :key="i">
              {{ e.name }}：{{ e.address }}
            </p>
          </div>
        </div>
      </div>
    </a-layout-footer>
    <div class="copyright">
      <span>©{{ year }} {{ name }} All Rights Reserved | {{ icp }}</span>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/logo-white.png'
import appConf from '@/config/config'
import HYQQLinks from '@/components/QQLinks'
const { name, icp, footerDesc, contact } = appConf

export default {
  name: 'Footer',
  components: { HYQQLinks },
  data() {
    return {
      logo,
      icp,
      name,
      footerDesc,
      contact,
    }
  },
  computed: {
    year() {
      return new Date().getFullYear()
    },
  },
}
</script>
<style lang="css" scoped>
.ant-layout-footer {
  color: #ffffff;
  background-color: #001529;
}
.ant-layout-footer .footer {
  width: 100%;
  display: flex;
  padding: 0 10%;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 10rem;
  font-size: 12px;
  color: #999;
}
.ant-layout-footer .footer h2 {
  font-size: 1.5em;
  color: #999;
}
.ant-layout-footer .footer a {
  font-size: 12px;
  color: #999;
}
.ant-layout-footer .footer a:hover {
  color: #fff;
}
.ant-layout-footer .footer .logo,
.ant-layout-footer .footer div[logo] {
  max-width: 180px;
  max-height: 180px;
}
.copyright {
  width: 100%;
  height: 80px;
  color: #999;
  line-height: 80px;
  text-align: center;
  border-top: 1px solid rgba(233, 233, 233, 0.1);
  background-color: #001529;
}
@media screen and (max-width: 666px) {
  .ant-layout-footer .footer {
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .ant-layout-footer .footer div {
    justify-content: center;
    align-items: center;
  }
}
</style>
